import createSetItemField from 'owa-mail-store/lib/services/utils/createSetItemField';
import itemChange from 'owa-service/lib/factory/itemChange';
import ItemId from 'owa-service/lib/contract/ItemId';
import itemId from 'owa-service/lib/factory/itemId';
import updateItemOperation from 'owa-service/lib/operation/updateItemOperation';
import UpdateItemRequest from 'owa-service/lib/contract/UpdateItemRequest';
import updateItemRequest from 'owa-service/lib/factory/updateItemRequest';
import UpdateItemResponseMessage from 'owa-service/lib/contract/UpdateItemResponseMessage';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
import RequestOptions from 'owa-service/lib/RequestOptions';

export interface UpdateCategoriesItemContext {
    itemId: ItemId;
    instanceKey: string;
    newCategoriesCollection: string[];
}

/**
 * Issues a service request to update items categories
 * @param itemContexts item contexts for updating categories
 * @param options request options
 * @returns a promise which contains UpdateItemResponse
 */
export default function updateItemsCategoriesService(
    itemContexts: UpdateCategoriesItemContext[],
    options: RequestOptions
): Promise<UpdateItemResponseMessage> {
    const requestBody = configureRequestBody(itemContexts);

    return updateItemOperation(
        {
            Header: getJsonRequestHeader(),
            Body: requestBody,
        },
        options
    ).then(response => {
        return response.Body.ResponseMessages.Items[0] as UpdateItemResponseMessage;
    });
}

/**
 * Configure the request body to update category for item
 * @param itemContexts item contexts for updating categories
 * @returns the request body of UpdateItemRequest
 */
function configureRequestBody(itemContexts: UpdateCategoriesItemContext[]): UpdateItemRequest {
    const changes = itemContexts.map(itemContext => {
        return itemChange({
            Updates: [createSetItemField('Categories', itemContext.newCategoriesCollection)],
            ItemId: itemId({
                Id: itemContext.itemId.Id,
                ChangeKey: itemContext.itemId.ChangeKey,
            }),
        });
    });

    return updateItemRequest({
        ItemChanges: changes,
        ConflictResolution: 'AlwaysOverwrite',
        MessageDisposition: 'SaveOnly',
    });
}
